import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { DemoComponent } from './demo.component';
import { ContainerComponent } from 'src/app/common/components/analysis/shared/container/container.component';
import { TileComponent } from "src/app/common/components/analysis/shared/tile/tile.component";
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { provideHighcharts } from 'highcharts-angular';
import { AuthInterceptorProvider } from 'src/app/common/interceptors/auth.interceptor';
import { OpenApiPathProvider } from 'src/app/common/util/open-api-provider';
import { DashboardComponent } from '@components/dashboard/dashboard.component';
import { HomeComponent } from '@components/home/home.component';
import { MainComponent } from '@components/main/main.component';

@NgModule({
  declarations: [DemoComponent],
  imports: [
    BrowserModule, MainComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [DemoComponent],
  providers: [
    provideRouter([]),
    AuthInterceptorProvider,
    OpenApiPathProvider,
    provideHttpClient(withInterceptorsFromDi()),
    provideHighcharts({
      options: {
        chart: {
          styledMode: true
        }

      },
    })
  ]
})
export class DemoModule {
  
}
